var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCool101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM7.8797 17.5302C8.17252 17.8232 8.6474 17.8233 8.94036 17.5305C9.73704 16.7342 10.8151 16.25 11.9996 16.25C13.1841 16.25 14.2621 16.7342 15.0588 17.5305C15.3518 17.8233 15.8267 17.8232 16.1195 17.5302C16.4123 17.2372 16.4122 16.7624 16.1192 16.4695C15.0578 15.4087 13.6047 14.75 11.9996 14.75C10.3945 14.75 8.94134 15.4087 7.87995 16.4695C7.58699 16.7624 7.58688 17.2372 7.8797 17.5302ZM15 11C15.5523 11 16 10.3284 16 9.5C16 8.67157 15.5523 8 15 8C14.4477 8 14 8.67157 14 9.5C14 10.3284 14.4477 11 15 11ZM18 13.7857C18 12.8389 16.5 11.5 16.5 11.5C16.5 11.5 15 12.8389 15 13.7857C15 14.7325 15.6716 15.5 16.5 15.5C17.3284 15.5 18 14.7325 18 13.7857ZM9 11C9.55228 11 10 10.3284 10 9.5C10 8.67157 9.55228 8 9 8C8.44771 8 8 8.67157 8 9.5C8 10.3284 8.44771 11 9 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCool101);
export default __webpack_public_path__ + "static/media/cool-10-1.c012d0b74bfcfdbef7156b88a5760b08.svg";
export { ForwardRef as ReactComponent };